module.exports = __webpack_public_path__ + "img/result-footer.cec02786.png";